import _id from "./_id";

export default function() {
    return _id;
}
